import SelectList from "types/SelectList";

const PAYMENT_OPTIONS: SelectList = [
  { value: "BILL_SHIPPER", label: "Bill Shipper" },
];

export default PAYMENT_OPTIONS;
